import { render, staticRenderFns } from "./FPagination.vue?vue&type=template&id=626d9d66&"
import script from "./FPagination.vue?vue&type=script&lang=ts&"
export * from "./FPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports